var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a8be2f28baae62712636b81742a666516f105f13"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["bradgarropycom@bradgarropy"]={id:"a8be2f28baae62712636b81742a666516f105f13"};
      